/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactfirmmessagetitle3Inputs */

const en_artifactfirmmessagetitle3 = /** @type {(inputs: Artifactfirmmessagetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firm message email`)
};

const pt_artifactfirmmessagetitle3 = /** @type {(inputs: Artifactfirmmessagetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email de interpelação amigável`)
};

/**
* | output |
* | --- |
* | "Firm message email" |
*
* @param {Artifactfirmmessagetitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactfirmmessagetitle3 = /** @type {((inputs?: Artifactfirmmessagetitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactfirmmessagetitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactfirmmessagetitle3(inputs)
	return pt_artifactfirmmessagetitle3(inputs)
});
export { artifactfirmmessagetitle3 as "artifactFirmMessageTitle" }